module.exports = __webpack_public_path__ + "static/media/howtobefat_img_5.a80e6295.png";